import React from 'react';
import { Link } from 'react-router-dom';
import { motion, useReducedMotion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import './CaseStudiesTeaser.css';

const featured = {
  industry: 'Retail',
  type: 'Conversational Agent',
  outcome: '3,000+ customer queries handled automatically every day',
  desc: 'A WhatsApp support agent for a retail business — order tracking, returns, and FAQs resolved without human escalation, integrated directly with their order system.',
  to: '/case-studies',
};

const compact = [
  {
    industry: 'Logistics',
    type: 'Workflow Agent',
    outcome: 'Invoice processing: 4 days → 4 hours',
    to: '/case-studies',
  },
  {
    industry: 'Market Intelligence',
    type: 'Research Agent',
    outcome: 'Daily competitor reports, zero manual work',
    to: '/case-studies',
  },
];

export const CaseStudiesTeaser = () => {
  const reduced = useReducedMotion();

  const reveal = {
    hidden: { opacity: 0, y: reduced ? 0 : 22 },
    show: (i = 0) => ({
      opacity: 1,
      y: 0,
      transition: { duration: reduced ? 0.2 : 0.55, delay: reduced ? 0 : i * 0.1, ease: [0.16, 1, 0.3, 1] },
    }),
  };

  return (
    <section className="cs-section">
      <div className="cs-container">
        <motion.div
          className="cs-header"
          variants={reveal}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, margin: '-80px' }}
        >
          <h2 className="cs-title">What we’ve built</h2>
          <Link to="/case-studies" className="cs-all">
            All case studies <ArrowRight size={15} />
          </Link>
        </motion.div>

        <div className="cs-grid">
          <motion.div
            variants={reveal}
            initial="hidden"
            whileInView="show"
            viewport={{ once: true, margin: '-80px' }}
            custom={0}
            className="cs-featured-wrap"
          >
            <Link to={featured.to} className="cs-featured">
              <div className="cs-tags">
                <span className="cs-tag industry">{featured.industry}</span>
                <span className="cs-tag type">{featured.type}</span>
              </div>
              <h3 className="cs-featured-outcome">{featured.outcome}</h3>
              <p className="cs-featured-desc">{featured.desc}</p>
              <span className="cs-link">Read case study <ArrowRight size={15} /></span>
            </Link>
          </motion.div>

          <div className="cs-compact-col">
            {compact.map((c, i) => (
              <motion.div
                key={c.outcome}
                variants={reveal}
                initial="hidden"
                whileInView="show"
                viewport={{ once: true, margin: '-80px' }}
                custom={i + 1}
                className="cs-compact-wrap"
              >
                <Link to={c.to} className="cs-compact">
                  <div className="cs-tags">
                    <span className="cs-tag industry">{c.industry}</span>
                    <span className="cs-tag type">{c.type}</span>
                  </div>
                  <h4 className="cs-compact-outcome">{c.outcome}</h4>
                  <span className="cs-link">Read case study <ArrowRight size={14} /></span>
                </Link>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
